module.exports = __webpack_public_path__ + "366da8f6bdf3e24684d19429b806e266.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/class.png
// module id = 541
// module chunks = 0